import Swiper from 'swiper'
export default function concept(gsap, ScrollTrigger){
  if(document.querySelectorAll('.site-concept').length > 0){
    gsap.fromTo('.site-concept .mainpic',
      {},
      {
        opacity: 1,
        scrollTrigger: {
          trigger: '.site-concept .mainpic',
          start: "top bottom",
          end: "top center",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )

    gsap.fromTo('.site-concept .kussion__pic img',
      {},
      {
        scale: 1.1,
        scrollTrigger: {
          trigger: '.site-concept .concept',
          start: "bottom bottom",
          end: "bottom top",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )

    gsap.fromTo('.site-concept .kussion__text',
      {},
      {
        top: '50%',
        opacity: 1,
        scrollTrigger: {
          trigger: '.site-concept .concept',
          start: "bottom top",
          end: "+=150%",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )

    ScrollTrigger.create({
      trigger: ".site-concept .kussion",
      start: "top top",
      end: "+=200%",
      pin: true,
      //markers: true
    })
  }
}